import { Label } from "@/components/ui/label";
import { AlertTriangle, ShieldCheck, ShieldAlert } from "lucide-react";

export const VERDICTS = [
  { v: "safe_to_proceed", l: "Safe to Proceed", color: "bg-[#059669]", icon: ShieldCheck },
  { v: "requires_mitigation", l: "Requires Mitigation", color: "bg-[#D97706]", icon: AlertTriangle },
  { v: "stop", l: "STOP — Do Not Proceed", color: "bg-[#DC2626]", icon: ShieldAlert },
];

export default function VerdictSelector({ verdict, setVerdict, readOnly }) {
  return (
    <div>
      <Label className="text-xs uppercase tracking-wider font-semibold text-gray-700">Overall Verdict</Label>
      <div className="mt-2 grid grid-cols-1 md:grid-cols-3 gap-3">
        {VERDICTS.map(({ v, l, color, icon: Icon }) => (
          <button
            key={v}
            type="button"
            disabled={readOnly}
            data-testid={`verdict-${v}`}
            onClick={() => setVerdict(v)}
            className={`flex items-center gap-3 border p-3 text-left transition-colors ${verdict === v ? "border-[#01ADEF] shadow-[0_0_0_1px_#01ADEF] bg-[#F0F7FF]" : "border-gray-200 hover:bg-gray-50"}`}
          >
            <div className={`w-9 h-9 ${color} flex items-center justify-center`}><Icon className="w-5 h-5 text-white" strokeWidth={2.5} /></div>
            <div className="text-sm font-semibold">{l}</div>
          </button>
        ))}
      </div>
    </div>
  );
}
